import { ArrowDownward } from '@material-ui/icons';
import React from 'react';

import ActionButton from '@/components/ActionButton';
import AsyncButton from '@/components/AsyncButton';

const MoveDownButton = props => (
  <ActionButton
    text="Опустить ниже"
    button={AsyncButton}
    icon={ArrowDownward}
    {...props}
  />
);

export default MoveDownButton;
